import { render, staticRenderFns } from "./ReviewAndSubmit.vue?vue&type=template&id=4ebd1953&"
import script from "./ReviewAndSubmit.vue?vue&type=script&lang=js&"
export * from "./ReviewAndSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ebd1953')) {
      api.createRecord('4ebd1953', component.options)
    } else {
      api.reload('4ebd1953', component.options)
    }
    module.hot.accept("./ReviewAndSubmit.vue?vue&type=template&id=4ebd1953&", function () {
      api.rerender('4ebd1953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/formcomponents/ReviewAndSubmit.vue"
export default component.exports